/**
 * Shared search function for ng-select components that need to search
 * across multiple fields including translations.
 *
 * Usage in component:
 * import { geographySearchFn } from 'src/app/Shared/_utils/geography-search.util';
 *
 * export class MyComponent {
 *   searchFn = geographySearchFn;
 * }
 *
 * In template:
 * <ng-select [searchFn]="searchFn" ...>
 */
export function geographySearchFn(term: string, item: any): boolean {
  if (!term) return true;
  const searchTerm = term.toLowerCase();

  // Search in English name
  if (item.name?.toLowerCase().includes(searchTerm)) return true;

  // Search in native name
  if (item.native?.toLowerCase().includes(searchTerm)) return true;

  // Search in all translations
  if (item.translations) {
    for (const key in item.translations) {
      if (item.translations[key]?.toLowerCase().includes(searchTerm)) {
        return true;
      }
    }
  }

  return false;
}
